import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';

import Select from 'react-select';

class ClientPermissions extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    users: []
  }
  componentWillMount() {
    Api.getUsersInAccount()
      .then(users => this.setState({users}))
      .catch(this.props.notify);
  }

  handleChange(item) {
    const {client} = this.props;
    if(item) {
      this.props.sendSocketEmit({
        client_id : client._id,
        user_id : item.value
      }, 'client-assign');
    }
  }

  render() {
    const { client, fields, users } = this.props;

    return (
			<div>
	      <hr className="dotted short" />
	      <p>Select a person to assign this client to: </p>
	      <div className="input-group">
	        <label className="input-group-addon">Assigned To: </label>
	          <Select
	            style={{borderRadius : '0px'}}
	            options={users && this.state.users ? [{user : users.user}, ...this.state.users.map(user => ({user}))].map(({user}) => ({
	              label : `${user._id == users.user._id ? '(Me)': ''} ${user.name && user.name.first && user.name.last ? `${user.name.first} ${user.name.last}` : user.username} - ${user.role}`,
	              value : user._id
	            })) : []}
	            onChange={this.handleChange.bind(this)}
	            value={client.owner ? client.owner._id : ''}
	          />
	      </div>
	    </div>
	    )
  }
}

const mapStateToProps = (state) => {
  const { client , fields , users } = state;
  return { users, client , fields : fields.Client || []};
};

export default connect(mapStateToProps, Actions)(ClientPermissions);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-permissions.js